import { FormController } from '@form-ts/core';
import { FeedbackFormData } from 'src/modules/feedback/types/FeedbackFormData';
import { FeedbackRequest } from 'src/modules/feedback/types/FeedbackRequest';
import { FormError } from 'src/modules/form/types/FormError';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const FEEDBACK_SEND = createActions<FormController<FeedbackFormData, FormError>, void>('FEEDBACK_SEND');
export const FEEDBACK_TRIGGER = createActions<void, FeedbackRequest>('FEEDBACK_TRIGGER');

export const FEEDBACK_OPEN = createTrigger<boolean>('FEEDBACK_OPEN');
